var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"activity-player"},[_c('close-button',{on:{"click":_vm.close}}),_c('iframe',{ref:"activity_iframe",attrs:{"src":_vm.src,"allow":"autoplay","onload":_vm.iFrameLoaded()}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }